module.exports = __webpack_public_path__ + "img/alter-ego-palette_jp.ea2a9e3.jpg";